import { createQuery } from 'react-query-kit';
import { AxiosError } from 'axios';
import { axios } from '..';

type TResponse = {
  message: string;
  total: number;
  data: {
    _id: string;
    userType: string;
    firstName: string;
    lastName: string;
    email: string;
    school: string;
    gender: string;
    isActive: boolean;
    awards: any[];
    createdAt: string;
    updatedAt: string;
    __v: number;
  }[];
};

type TData = {
  id: string;
};

// eslint-disable-next-line import/prefer-default-export
export const useTeacher = createQuery<TResponse, TData, AxiosError>({
  primaryKey: '/teachers',
  queryFn: ({ queryKey: [, variables] }) =>
    axios
      .get(`/School/teachers/view_teachers/${variables.id}`)
      .then((response) => response.data)
});
